import { Component } from '@theme/component';

class KbCollectionServices extends Component {
  requiredRefs = ['group'];
  #observer;

  connectedCallback() {
    super.connectedCallback();
    this.#observer = new ResizeObserver(this.#measure);
    this.#observer.observe(this.refs.group);
    this.#measure();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    super.disconnectedCallback();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#observer?.disconnect();
    if (this.refs.group) this.#observer?.observe(this.refs.group);
    this.#measure();
  }

  #measure = () => {
    const width = this.refs.group?.getBoundingClientRect().width;
    if (!width) return;
    this.style.setProperty('--kb-services-duration', `${width / 22}s`);
    this.setAttribute('data-ready', '');
  };
}

if (!customElements.get('kb-collection-services')) {
  customElements.define('kb-collection-services', KbCollectionServices);
}
